<template>
  <a v-if="isGranted('DOWNLOAD_POST_IMPORT_FILE')" :href="url">
    <q-btn
      icon="fa fa-download"
      class="text-dark"
      title="Download file"
      v-bind="$attrs"
      round
    />
  </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { isGranted } from '@/social/auth';

export default defineComponent({
  props: {
    postImportId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    url(): string {
      return `${window.env.SOCIAL.URL}/post-imports/${this.postImportId}/file`;
    },
  },
  methods: {
    isGranted,
  },
});
</script>
